import { render, staticRenderFns } from "./MenuGeneratorSegment.vue?vue&type=template&id=6c632b2a"
import script from "./MenuGeneratorSegment.vue?vue&type=script&lang=js"
export * from "./MenuGeneratorSegment.vue?vue&type=script&lang=js"
import style0 from "./MenuGeneratorSegment.vue?vue&type=style&index=0&id=6c632b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports